import { uniqueId, uniqueJId } from '../../../helpers/unique-id';

function createJourneyLegsDuplicateMap(journeyLegs) {
  const map = {};

  journeyLegs.forEach((item) => {
    map[item.id] = `${uniqueId()}`;
  });

  return map;
}

function createjIdDuplicateMap(journeyTree = []) {
  const map = {};

  journeyTree.forEach((item) => {
    if (item.jId && item.jId !== '1') {
      map[item.jId] = `${uniqueJId()}`;
    }

    if (item.substituteJId) {
      map[item.substituteJId] = `${uniqueJId()}`;
    }
  });

  return map;
}

function createJtreeMainIdDuplicateMap(journeyTree = []) {
  const map = {};

  journeyTree.forEach((item) => {
    map[item._id] = `${uniqueId()}`;
  });

  return map;
}

function getJourneyLegs(journeyLegs, journeyLegsDuplicateMap, parentId) {
  const newLegs = [];

  for (let index = 0; index < journeyLegs.length; index++) {
    const leg = journeyLegs[index];

    newLegs.push({
      ...leg,
      parentId,
      id: journeyLegsDuplicateMap[leg.id],
    });
  }

  return newLegs;
}

function getJourneyTree(
  journeyTree,
  journeyLegsDuplicateMap,
  jIdDuplicateMap,
  jtreeMainIdDuplicateMap
) {
  const newJourneyTree = [];

  for (let index = 0; index < journeyTree.length; index++) {
    const treeItem = journeyTree[index];

    const item = {
      ...treeItem,
    };

    // set  _id
    if (item._id && jtreeMainIdDuplicateMap[item._id]) {
      item._id = jtreeMainIdDuplicateMap[item._id];
    }

    // set JID
    if (item.jId && jIdDuplicateMap[item.jId]) {
      item.jId = jIdDuplicateMap[item.jId];
    }

    // Substitute JId
    if (item.substituteJId && jIdDuplicateMap[item.substituteJId]) {
      item.substituteJId = jIdDuplicateMap[item.substituteJId];
    }

    // set ID
    if (item.id) {
      const [id, jId] = item.id.split('#');

      const newId = journeyLegsDuplicateMap[id];
      const newJId = jIdDuplicateMap[jId];

      item.id = `${newId || id}#${newJId || jId}`;
    }

    // parent
    if (item.parent && jtreeMainIdDuplicateMap[item.parent]) {
      item.parent = jtreeMainIdDuplicateMap[item.parent];
    }

    // children
    if (item?.children?.length) {
      item.children = item.children
        .map((childId) => jtreeMainIdDuplicateMap[childId])
        .filter((childId) => childId);
    }

    // value
    if (item.value && journeyLegsDuplicateMap[item.value]) {
      item.value = journeyLegsDuplicateMap[item.value];
    }

    newJourneyTree.push(item);
  }

  console.log(journeyTree, newJourneyTree);

  return newJourneyTree;
}

export function duplicateLeg(allLegs = [], targetLegId) {
  const newLegId = `${uniqueId()}`;

  const targetIndex = allLegs.findIndex((l) => l.id === targetLegId);
  const targetLeg = allLegs.find((l) => l.id === targetLegId);

  const newLeg = {
    ...targetLeg,
    id: newLegId,
    updatedAtJourney: Date.now(),
  };

  const journeyLegsOld =
    allLegs?.filter((item) => item.parentId && item.parentId === targetLegId) ||
    [];

  const journeyLegsDuplicateMap = createJourneyLegsDuplicateMap(journeyLegsOld);
  const jIdDuplicateMap = createjIdDuplicateMap(targetLeg.journeyTree || []);
  const jtreeMainIdDuplicateMap = createJtreeMainIdDuplicateMap(
    targetLeg.journeyTree
  );

  const journeyLegs = getJourneyLegs(
    journeyLegsOld,
    journeyLegsDuplicateMap,
    newLegId
  );

  const journeyTree = getJourneyTree(
    targetLeg.journeyTree || [],
    journeyLegsDuplicateMap,
    jIdDuplicateMap,
    jtreeMainIdDuplicateMap
  );

  if (targetLeg.journeyTree) {
    newLeg.journeyTree = journeyTree;
  }

  const newArray = [...allLegs, ...journeyLegs];

  newArray.splice(targetIndex + 1, 0, newLeg);

  return newArray;
}
